import React, { useCallback } from "react";
import { useSelector } from "react-redux";

import { Row, Column } from "components/Layout";
import NTMSelect from "components/Buttons/NTMSelect";
import ElementModal from "./ElementModal";
import SettingItem from "containers/Settings/SettingItem";

import { settings as SETTINGS } from "../../constants";
import style from './_modal.module.scss';
import NTMButton from "components/Buttons/NTMButton";


export default function AdversitySusceptibilityModal({
	isOpen, onClose, onSubmit, getSettingValue, changeSetting, changeMultipleSettings, deleteSetting, adversity,
	devices, device, changeDevice,
}) {
	let project = useSelector(store => store.session.project)
	let susceptibilityItem, adversityItems = []

	const changeSusceptibility = useCallback((susceptibilityItem, selectedSusceptibility, adversityItems) => {
		let settingsToChange = []
		settingsToChange.push({
			name: susceptibilityItem.name,
			value: selectedSusceptibility.value,
			type: project.projectTypeId,
			project: project.id,
			device: device.id
		})
		adversityItems.forEach(i => {
			let paramObj, value
			paramObj = adversity?.susceptibilityParams.find(p => p.name === i.name)
			if (paramObj) {
				value = paramObj.values[selectedSusceptibility.value]
			}
			if (value) {
				settingsToChange.push({
					name: i.name,
					value: value,
					type: project.projectTypeId,
					project: project.id,
					device: device.id
				})
			}
		})
		changeMultipleSettings(settingsToChange)
	}, [project, device, adversity, changeMultipleSettings])

	if (!adversity) return null
	if (adversity.susceptibilitySettingName) {
		susceptibilityItem = SETTINGS.settingItems[project.projectTypeName].find(s => s.name === adversity.susceptibilitySettingName)
	}
	if (adversity.susceptibilityParams) {
		let adversityParamNames = adversity.susceptibilityParams.map(p => p.name)
		adversityItems = SETTINGS.settingItems[project.projectTypeName].filter(s => adversityParamNames.includes(s.name))
	}

	return (
		<ElementModal className={style.modal} isOpen={isOpen} onClose={onClose} submit={onSubmit}>
			<Row>
				<NTMSelect value={device.id} onChange={e => changeDevice(e.target.value)}>
					{devices.map(d =>
						<option key={d.id} value={d.id}>{d.label || d.device}</option>
					)}
				</NTMSelect>
			</Row>
			<Row className={style.susceptibilityItem}>
				<Column>
					<label>{susceptibilityItem.label}</label>
					<div>{susceptibilityItem.description}</div>
				</Column>
				<Row>{
					susceptibilityItem.options.map(o => (
						<NTMButton
							key={o.name}
							primary={getSettingValue(susceptibilityItem.name, project.projectTypeId, project.id, device.id)?.value !== o.value ? 'true' : undefined}
							onClick={() => changeSusceptibility(susceptibilityItem, o, adversityItems)}
						>{o.name}</NTMButton>
					))
				}</Row>
			</Row>
			<section>{
				adversityItems.map(sItem =>
					<SettingItem
						key={sItem.name}
						containerScope={SETTINGS.scopes.DEVICE}
						className={style.settingItem}
						settingItem={sItem}
						onChange={v => changeSetting(sItem.name, v, project.projectTypeId, project.id, device.id)}
						setting={getSettingValue(sItem.name, project.projectTypeId, project.id, device.id)}
						onDelete={deleteSetting}
					/>
				)
			}</section>
		</ElementModal>
	)
}
